// The price: an amount and a currency, per unit of the deal's volume (TX-US-0039). It has no unit
// of its own - the volume's is shown beside it - which is what lets the value be computed without
// a conversion.

import ListSelect from './ListSelect.jsx';

export default function PriceInput({
  amount, currency, currencies, unit, onAmount, onCurrency, error, onAdded, canAdd = false,
  flag = null,
}) {
  return (
    <fieldset className="quantity">
      <legend>Price{flag}</legend>
      <label className="field">
        <span className="field-label">Amount{unit ? ` per ${unit}` : ''}</span>
        {/* A string all the way to the server, as the volume is: the digits typed are the digits
            stored. */}
        <input inputMode="decimal" value={amount} onChange={(e) => onAmount(e.target.value)}
               placeholder="650.00" />
        {!unit && amount.trim() && (
          <span className="hint">A price is per unit of the volume: give the volume first.</span>
        )}
      </label>
      <ListSelect label="Currency" listName="currency" entries={currencies} value={currency}
                  onChange={onCurrency} onAdded={onAdded} canAdd={canAdd} />
      {error && <span className="field-error">{error}</span>}
    </fieldset>
  );
}
